/**
 * @desc: - 面板- 分类显示，带ICON 链接 文字
 * @param  {[STRING]}  displaySet    [{className: 'i_icon-cpyx', url: '', cnName:'', enName}]
 * @param  {[ARRAY]}  lotterMenus    [导航类名集合] - [数据格式参考lotteryMenus.js]
 * @author: vico
 */
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as baseAction from '../../actions/baseAction';
import { DOMAIN } from '../../constants/config';
import { DISABLE_LOTTERY_IDS } from '../../constants/lotterys/config'

import HYpk10 from  '../../i/pc-day/hy/bjpk10c.png';
import HYtxffc   from  '../../i/pc-day/hy/txffcc.png';
import HYcqssc   from  '../../i/pc-day/hy/cqsscc.png';
import HYjnd30m   from  '../../i/pc-day/hy/jnd30sc.png';
import HYydlpk10   from  '../../i/pc-day/hy/ydlpk10c.png';

import pk10 from  '../../i/pc-day/lottery/logo/bjpk10.png';
import txffc   from  '../../i/pc-day/lottery/logo/txffc.png';
import cqssc   from  '../../i/pc-day/lottery/logo/cqssc.png';
import jnd30m   from  '../../i/pc-day/lottery/logo/jnd30s.png';
import ydlpk10   from  '../../i/pc-day/lottery/logo/ydlpk10.png';


class DropDownWithCategory extends React.Component {

  constructor(props) {
    super(props);
    
  }

  // componentDidMount(){
  //   window.addEventListener('resize',this.onreSizeWidth);
  //   let _width =  document.body.clientWidth;
  //   if(_width<1080){
  //     document.querySelector('.navWidth').style.width=1080+'px';
  //     document.querySelector('.navWidth').style.left = '-480px';
  //   }else{
  //     ReactDOM.findDOMNode( this.refs.navWidth ).style.width = _width+"px";
  //     ReactDOM.findDOMNode( this.refs.navWidth ).style.left = '-'+ (480+(_width-1080)/2)+ 'px';
  //   }
  // }

  // componentWillUnmount() {
  //    document.removeEventListener('resize', this.onreSizeWidth, false);
  // }

  // onreSizeWidth(){
  //     let _widthz =  document.body.clientWidth;
  //     if(_widthz<1080){
  //       document.querySelector('.navWidth').style.width=1080+'px';
  //       document.querySelector('.navWidth').style.left = '-480px';
  //       return;
  //     }

  //     document.querySelector('.navWidth').style.width=_widthz+"px";
  //     document.querySelector('.navWidth').style.left ='-'+ (480+(_widthz-1080)/2)+ 'px';
  // }

  switchLottery(uri, target, lotteryId){
    const {handleClick} = this.props;
    document.querySelector('.actived.pannel-li').className='pannel-li'
    // 临时屏蔽，敬请期待
    if (_.includes(DISABLE_LOTTERY_IDS, lotteryId)) {
      return this.props.$$BASE.openToast('近期开放，敬请期待');
    }
    if (window.METHODS.autheError) {
      this.props.$$BASE.openAlert(window.METHODS.autheError.message);
      return;
    }
    if (target == '_blank') {
      window.open(uri);
    }else{
      window.location.href = uri;
    }
  }

  hideChild(){
    document.querySelector('.actived.pannel-li').className='pannel-li';
  }



  render() {
    const {lotterMenus} = this.props;
    const vers = $.getCookie('vers');
    // 下级菜单
    var childNavs =  $.makeLott(lotterMenus).map((row, index) => {
      return <dl className={row.className} key={index}>
        <dt>{row.categoryName}</dt>
        {
          row.lotterys.map((row_c, index_c) => {
            return <dd key={index_c}>
                      <a ref="noddom" onClick={this.switchLottery.bind(this, row_c.uri, row_c.target, row_c.lotteryId)} className='pointer' >
                          <b>{row_c.name}</b>
                          <span className={row_c.type}></span>
                      </a>
                  </dd>
          })
        }
      </dl>
    })

    return (
      <div className="nav-child navWidth" ref='navWidth'>
        <div className="main-title">
            彩票玩法
              <span className="manycai" onClick={() => window.open('https://manycaia1.net/?hmsr=hengcai&hmpl=%E6%81%86%E5%BD%A9&hmcu=&hmkw=&hmci=#/lotteryChart')}>
              【多彩网】 专业彩号分析 . 数据趋势图 . 提升中奖率
              </span>
          </div>
        <div className="nav-child-1040">
          {childNavs}
          <div className="clear-botn"></div>
          <div className="nav-child-list-img">
              {
                  vers == 'hy' ?
                      <ul>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/animate/pk10/1"><img src={HYpk10}/></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/ydl10/cg"><img src={HYydlpk10}  /></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/txffc/cg"><img src={HYtxffc}  /></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/cqssc/cg"><img src={HYcqssc}  /></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/jnd30m/cg"><img src={HYjnd30m}  /></a></li>
                      </ul>
                      :
                      <ul>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/animate/pk10/1"><img src={pk10}/></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/ydl10/cg"><img src={ydlpk10}  /></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/txffc/cg"><img src={txffc}  /></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/cqssc/cg"><img src={cqssc}  /></a></li>
                          <li onClick={this.hideChild.bind(this)}><a href="#/lottery/ssc/jnd30m/cg"><img src={jnd30m}  /></a></li>
                      </ul>
              }

          </div>
        </div>
      </div>
    );
  }
}

reactMixin(DropDownWithCategory.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropDownWithCategory)